import { Component, OnInit, inject, DestroyRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TenantService } from 'src/app/services/api/tenant.service';
import { MatDialog } from '@angular/material/dialog';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { translate } from '@jsverse/transloco';
import { SidenavService } from 'src/app/services/util/sidenav.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CustomToastrService } from 'src/app/services/util/toastr.service';
import { Constants } from 'src/app/models/constants';
import { ConfirmationDialogComponent } from 'src/app/components/confirmation-dialog/confirmation-dialog.component';

@Component({
    selector: 'app-create-tenant2.0',
    templateUrl: './create-tenant2.0.component.html',
    styleUrls: ['./create-tenant2.0.component.scss'],
    standalone: false
})
export class CreateTenant20Component   implements OnInit {
  Constants = Constants;
  tenantForm: FormGroup;
  loading = false;
  submitted = false;
  subscriptionDataTest: any;
  subscriptionDataPii: any;
  testSubscribe: any;
  piiSubscribe: any;
  successMessage: any;
  isLoading = false;
private destroyRef = inject(DestroyRef);
  regions: any = ['APAC', 'Australia', 'Brazil', 'Canada', 'China', 'China_2', 'Europe', 'India', 'India_2', 'Japan', 'North_America',
    'North_America_2', 'North_America_3', 'North_America_4', 'UK'];

  cloud: any = ['Azure', 'AWS'];

  managementType: any = ['external', 'external_for_action'];

  constructor(private fb: FormBuilder, private tenantService: TenantService, private toastrService: CustomToastrService,
     private sidenavService: SidenavService, private dialog: MatDialog) {
    
  }

  ngOnInit(): void {
    const formConfig: any = {
      tenantId: ['', [Validators.required]],
      cloudProvider: ['', [Validators.required]],
      managementType: ['', [Validators.required]],
      clientName: ['', [Validators.required]],
      regionPair: ['', [Validators.required]]
    };
    this.tenantForm = this.fb.group(formConfig);
  }

  onSubmit(): void {
    if(!FormUtilService.validateForm(this.tenantForm)) {
      return;
    }
    const data = this.tenantForm.value;
    this.createTenant();
  }

  cancel(): void {
    this.tenantForm.reset();
  }

  closeSidenav(): void {
     this.sidenavService.closeRightSidenav();
  }

  /**
   * On clicking submit button, A new Tenant will get deployed.
   */
  private createTenant(): void {
    const tenantFormIsValid = FormUtilService.validateForm(this.tenantForm);
    if (tenantFormIsValid) {
      this.dialog.open(ConfirmationDialogComponent, {
        panelClass: 'default-dialog-wrapper',
        width: '566px',
        autoFocus: false,
        data: {
          title: translate('TENANT_FORM.TITLE'),
          message:translate('TENANT_FORM.MESSAGE'),
          confirmButtonText: translate('BUTTONS.CONFIRM')
        }
      })
        .afterClosed()
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(confirm => {
          if (confirm) {
            const tenant = this.tenantForm.getRawValue();
            this.isLoading = true;
            this.tenantService.createTenantRegister(tenant)
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe({
              next: (res) => {
                this.isLoading = false;
                this.sidenavService.closeRightSidenav('data');
            setTimeout(() => {
              const title = translate('INSTANCE_STATUS.TENANT');
              const message = translate('TENANT_FORM.TENANT_ADDED');
              this.toastrService.successMessage(message, title);
            }, 500);
              },
              error: (error) => {
                this.isLoading = false;
                const errorMessage = typeof error === 'string' ? error: typeof error?.error === 'string' ? error.error : error;
                this.dialog.open(ErrorDialogComponent, {
                  minHeight: '342px',
                  width: '630px',
                  panelClass: 'flex-dialog',
                  data: {
                    title:  translate('ERROR_DIALOG.ADD_TENANT_FAILED'),
                    description: errorMessage
                  }
                });
              }
            });
          }
      });
    }
  }

  get formControls(): any {
    return this.tenantForm.controls;
  }

}

